import {ActionList} from '@primer/react'
import sidebarListStyles from './SidebarActionList.module.css'
import {clsx} from 'clsx'
import {useAvailableStateChangeActions} from '../state-change-actions/use-available-state-change-actions'
import {
  MarkReadyForReviewAction,
  MarkReadyForReviewFailureDialog,
  useMarkReadyForReviewActionMutation,
} from '../state-change-actions/MarkReadyForReviewAction'
import {
  ConvertToDraftAction,
  ConvertToDraftFailureDialog,
  useConvertToDraftActionMutation,
} from '../state-change-actions/ConvertToDraftAction'
import {CloseAction, CloseFailureDialog, useCloseActionMutation} from '../state-change-actions/CloseAction'
import {ReopenAction, ReopenFailureDialog, useReopenActionMutation} from '../state-change-actions/ReopenAction'

export function SidebarActions() {
  const markReadyForReviewMutation = useMarkReadyForReviewActionMutation()
  const convertToDraftMutation = useConvertToDraftActionMutation()
  const closeMutation = useCloseActionMutation()
  const reopenMutation = useReopenActionMutation()

  const visibleActions = useAvailableStateChangeActions({
    markReadyForReviewMutation,
    convertToDraftMutation,
    closeMutation,
    reopenMutation,
  })

  return (
    <>
      {visibleActions.length > 0 && (
        <div data-overview-sidebar-item>
          <ActionList
            variant="full"
            aria-label="Pull request actions"
            className={clsx(sidebarListStyles.flush, sidebarListStyles.compact)}
          >
            {visibleActions.map(name => {
              switch (name) {
                case 'mark-ready':
                  return <MarkReadyForReviewAction key={name} mutation={markReadyForReviewMutation} />
                case 'convert-to-draft':
                  return <ConvertToDraftAction key={name} mutation={convertToDraftMutation} />
                case 'close':
                  return <CloseAction key={name} mutation={closeMutation} />
                case 'reopen':
                  return <ReopenAction key={name} mutation={reopenMutation} />
              }
            })}
            {/* TODO: Lock conversation */}
          </ActionList>
        </div>
      )}

      <MarkReadyForReviewFailureDialog mutation={markReadyForReviewMutation} />
      <ConvertToDraftFailureDialog mutation={convertToDraftMutation} />
      <CloseFailureDialog mutation={closeMutation} />
      <ReopenFailureDialog mutation={reopenMutation} />
    </>
  )
}
